const CouponRateType = Object.freeze({
  AMOUNT: "Amount",
  PERCENTAGE: "Percentage",
});

export default CouponRateType;
